
import { List, PullRefresh } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { PageResult } from '@/types/train-netWork'
import { AuthLocationInfoType } from '@/types/public'
import { parseTrainNetworkPoint } from '@/utils/dataFactory'
import { refreshTrainPageSetup } from '@/compositions/refreshPage'
import { NetWorkItem, TrainNetworkQuery } from '@/types/train-netWork'
import { defineComponent, ref, Ref, toRefs, watch, onUnmounted } from 'vue'
import { GetTrainNetworkpoints } from '@/apis/train-work'
import { TrainNetworkItemStorage } from '@/storage/train-network'
import { UserLocationInfoStorage } from '@/storage/common'

export default defineComponent({
  name: 'train-Points',
  components: {
    VanList: List,
    VanPullRefresh: PullRefresh,
  },
  props: {
    keywords: {
      type: String,
      required: true,
    },
  },
  emits: ['clickItem'],
  setup(props, context) {
    const router = useRouter()
    const storageData = UserLocationInfoStorage.get<AuthLocationInfoType>()

    const is_only_own = useRoute().query.is_only_own as string | undefined
    const { keywords } = toRefs(props)
    let items: Ref<NetWorkItem[]> = ref([])
    let {
      error,
      loading,
      finished,
      refreshing,
      _query,
      _ts,
      generateLoad,
      generateRefresh,
      errorDealFunc,
    } = refreshTrainPageSetup()
    let timer: number
    const reGetItems = () => {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        _ts = Date.now()
        items.value = []
        if (finished.value) {
          _query.page = 0
          finished.value = false
        } else {
          loading.value = true
          _query.page = 1
          getItems()
        }
      }, 500)
    }
    watch(keywords, (): void => {
      reGetItems()
    })
    const getItems = async (): Promise<void> => {
      if (!storageData?.lat || !storageData?.lng) {
        if (_query.page > 0) {
          _query.page--
        }
        return
      }
      const ts: number = _ts
      const { lng = 0, lat = 0 } = storageData

      const obj: TrainNetworkQuery = Object.assign({}, _query, {
        keywords: keywords.value as string,
        lng: Number(lng),
        lat: Number(lat),
      })
      try {
        const result: PageResult = await GetTrainNetworkpoints(obj)
        console.log('result')
        if (ts !== _ts) return
        if (refreshing.value) {
          items.value = []
          refreshing.value = false
        }
        let list = (result?.data as NetWorkItem[]) || []
        console.log('list', list)
        list.forEach((it) => parseTrainNetworkPoint(it))
        items.value = _query.page === 1 ? list : items.value.concat(...list)
        loading.value = false
        finished.value = list.length < _query.per_page
      } catch (err: unknown) {
        if (ts !== _ts) return
        errorDealFunc(err as { message: string })
      }
    }
    const onLoad = generateLoad(getItems)
    const onRefresh = generateRefresh(getItems)
    const onClickItem = (item: NetWorkItem) => {
      TrainNetworkItemStorage.set(JSON.stringify(item))
      context.emit('clickItem')
      const obj = {
        name: 'train-network-detail',
        query: {
          guid: item.guid,
        },
      }
      router.push(obj)
    }
    onUnmounted(() => {
      if (timer) clearTimeout(timer)
    })
    return {
      onClickItem,
      error,
      loading,
      finished,
      refreshing,
      items,
      onLoad,
      onRefresh,
      getItems,
    }
  },
})
